var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.76 62.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Naamloos_verloop_238-6);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        opacity: .86;\n      }\n\n      .cls-2 {\n        fill: url(#Naamloos_verloop_238-8);\n      }\n\n      .cls-3 {\n        fill: url(#Naamloos_verloop_238-7);\n      }\n\n      .cls-4 {\n        fill: url(#Naamloos_verloop_238-5);\n      }\n\n      .cls-5 {\n        fill: url(#Naamloos_verloop_238-4);\n      }\n\n      .cls-6 {\n        fill: url(#Naamloos_verloop_238-2);\n      }\n\n      .cls-7 {\n        fill: url(#Naamloos_verloop_238-3);\n      }\n\n      .cls-8 {\n        fill: url(#Naamloos_verloop_238);\n      }\n\n      .cls-9 {\n        fill: url(#Naamloos_verloop_389);\n      }\n\n      .cls-9, .cls-10 {\n        opacity: .85;\n      }\n\n      .cls-10 {\n        fill: url(#Naamloos_verloop_39);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_39",
    "data-name": "Naamloos verloop 39",
    x1: 14.84,
    y1: 27.14,
    x2: 45.26,
    y2: 27.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ededee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#e9e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#e0e0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#b9b9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c9c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_389",
    "data-name": "Naamloos verloop 389",
    x1: 29.34,
    y1: 75.02,
    x2: 33.38,
    y2: -15.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3e7e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238",
    "data-name": "Naamloos verloop 238",
    x1: 37.37,
    y1: 27.1,
    x2: 54.29,
    y2: 27.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee7486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ee7184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#ef6a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f25d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f54b64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fa3351"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1a3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-2",
    "data-name": "Naamloos verloop 238",
    x1: 36.08,
    y1: 22.1,
    x2: 54.26,
    y2: 22.1,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-3",
    "data-name": "Naamloos verloop 238",
    x1: 22.56,
    y1: 27.1,
    x2: 5.88,
    y2: 27.1,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-4",
    "data-name": "Naamloos verloop 238",
    x1: 23.76,
    y1: 18.54,
    x2: 6.95,
    y2: 25.14,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-5",
    "data-name": "Naamloos verloop 238",
    x1: 33.66,
    y1: 11.15,
    x2: 47.64,
    y2: 11.15,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-6",
    "data-name": "Naamloos verloop 238",
    x1: 32.35,
    y1: 6.9,
    x2: 47.62,
    y2: 6.9,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-7",
    "data-name": "Naamloos verloop 238",
    x1: 26.25,
    y1: 11.15,
    x2: 12.45,
    y2: 11.15,
    xlinkHref: "#Naamloos_verloop_238"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Naamloos_verloop_238-8",
    "data-name": "Naamloos verloop 238",
    x1: 27.12,
    y1: 3.89,
    x2: 13.26,
    y2: 9.85,
    xlinkHref: "#Naamloos_verloop_238"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M14.9,50.59h0c-.15-.41-.02-.86.32-1.13l13.21-10.35-7.7-6c-.51-.4-.81-1.01-.82-1.65,0,0,0-.01,0-.02-.01-.68.32-1.33.87-1.74l7.6-5.59-5.47-4.12c-.47-.35-.65-.96-.47-1.52,0,0,0-.01,0-.02.09-.26.26-.49.48-.65l5.37-3.94-3.28-2.46c-.46-.35-.66-.94-.49-1.49,0,0,0-.02,0-.02.09-.28.26-.53.49-.71l3.39-2.56-2.32-1.8c-.44-.34-.52-.97-.18-1.4.34-.44.97-.52,1.4-.18l2.75,2.13,2.67-2.02c.44-.33,1.07-.24,1.4.2.33.44.25,1.07-.2,1.4l-2.24,1.69,3.35,2.59c.45.34.63.93.46,1.47,0,0,0,.01,0,.02-.09.27-.26.51-.49.68l-3.37,2.47,5.48,4.11c.46.34.65.93.48,1.48,0,0,0,.01,0,.02-.09.27-.26.52-.49.69l-5.4,3.97,8.32,6.27c.44.33.64.9.49,1.44,0,0,0,.01,0,.02-.08.28-.24.52-.47.7l-8.38,6.55,13.18,10.27c.34.27.48.72.35,1.13h0c-.14.42-.53.71-.98.71l-28.39.03c-.42,0-.79-.26-.94-.66ZM18.71,49.25h22.73l-11.38-8.87-11.35,8.87ZM21.82,31.42l8.24,6.42,8.12-6.35-8.13-6.12-8.23,6.05ZM39.14,32.22s.01,0,.02.01h-.02ZM24.81,18.92l5.26,3.96,5.19-3.81-5.27-3.95-5.17,3.8ZM36.26,19.82s0,0,0,0h0ZM26.88,10.3l3.11,2.33,3.17-2.33-3.1-2.4-3.18,2.4ZM34.14,11.05s0,0,0,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.77,61.75c-.45,0-.86-.31-.97-.77L32,2.79c-.04-.15-.17-.26-.33-.26h-3.33c-.16,0-.29.11-.33.26l-13.87,58.05c-.13.54-.67.87-1.21.74-.54-.13-.87-.67-.74-1.21L26.08,2.33c.25-1.06,1.19-1.79,2.27-1.79h3.33c1.09,0,2.02.74,2.27,1.8l13.8,58.18c.13.54-.2,1.08-.74,1.2-.08.02-.16.03-.23.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M53.29,29.92c-.55,0-1-.45-1-1v-2.63h-13.92c-.55,0-1-.45-1-1s.45-1,1-1h14.9c.55,0,.99.44,1,.99l.02,3.64c0,.55-.45,1-1,1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.26,26.29c-.12,0-.25-.02-.37-.07l-16.18-6.38c-.51-.2-.77-.78-.56-1.3.2-.51.78-.77,1.3-.56l16.18,6.38c.51.2.77.78.56,1.3-.16.39-.53.63-.93.63Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M6.96,29.92c-.55,0-1-.45-1-1v-3.63c0-.52.42-.95.95-.95l14.72-.04c.55,0,1,.45,1,1s-.45,1-1,1H7.96v2.63c0,.55-.45,1-1,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.98,26.29c-.39,0-.77-.23-.92-.62-.21-.51.03-1.1.54-1.31,1.63-.67,15.95-6.57,16.07-6.63.51-.2,1.09.05,1.3.56.2.51-.04,1.09-.56,1.3-.28.11-16.05,6.62-16.05,6.62-.12.05-.25.08-.38.08Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.64,13.65c-.55,0-1-.45-1-1v-2.01h-10.99c-.55,0-1-.45-1-1s.45-1,1-1h11.94c.55,0,1,.45,1.01,1l.03,3.01c0,.55-.45,1-1,1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.62,10.64c-.13,0-.26-.02-.38-.08l-13.27-5.48c-.51-.21-.75-.8-.54-1.31.21-.51.8-.75,1.31-.54l13.27,5.48c.51.21.75.8.54,1.31-.16.39-.53.62-.92.62Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.56,13.65c-.55,0-1-.45-1-1v-2.98c0-.55.44-.99.99-.99l11.8-.04c.55,0,1,.45,1,1s-.45,1-1,1h-10.79v2.01c0,.55-.45,1-1,1Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.57,10.64c-.39,0-.76-.23-.92-.61-.21-.51.03-1.1.54-1.31,3.05-1.28,13-5.44,13.1-5.48.51-.2,1.09.05,1.3.56.2.51-.05,1.09-.56,1.3-.3.12-13.07,5.47-13.07,5.47-.13.05-.26.08-.39.08Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNet);
export default __webpack_public_path__ + "static/media/icon_net.68b17487a36f29176f1d3de2d009dc9d.svg";
export { ForwardRef as ReactComponent };